/* eslint-disable */
type CrTimestamp = number;
type CrJson = any;
type CrBigInt = number;
/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetMaximumBenefit
// ====================================================

export interface GetMaximumBenefit_payment_event_list_for_display_item_list_payment_event_detail_list {
  /**
   * 최소 금액
   */
  min_amount: number;
  /**
   * 할인 금액
   */
  discount_amount: number;
}

export interface GetMaximumBenefit_payment_event_list_for_display_item_list {
  /**
   * 결제수단
   */
  payment_method: PaymentMethod;
  /**
   * 간편결제(페이류) 타입
   */
  payment_method_type: string | null;
  /**
   * 금융사 코드
   */
  financial_company_code: FinancialCompanyCode | null;
  /**
   * 이벤트 타입
   */
  event_type: VendorEventType;
  /**
   * 생성 날짜
   */
  date_created: CrTimestamp;
  /**
   * 시작 날짜
   */
  date_started: CrTimestamp;
  /**
   * 종료 날짜
   */
  date_ended: CrTimestamp;
  /**
   * 노출 순서
   */
  priority: number;
  /**
   * 결제 이벤트 상세 정보 목록
   */
  payment_event_detail_list: GetMaximumBenefit_payment_event_list_for_display_item_list_payment_event_detail_list[];
}

export interface GetMaximumBenefit_payment_event_list_for_display {
  /**
   * 결제 이벤트 정보 목록
   */
  item_list: GetMaximumBenefit_payment_event_list_for_display_item_list[];
}

export interface GetMaximumBenefit_payment_notification_list_item_list_payment_notification_content_list {
  /**
   * 언어 코드
   */
  language: string;
  /**
   * 내용
   */
  content: string;
}

export interface GetMaximumBenefit_payment_notification_list_item_list {
  /**
   * 기본 키
   */
  id: string;
  /**
   * 결제 수단
   */
  payment_method: PaymentMethod;
  /**
   * 알림 타입
   */
  notification_type: PaymentNotificationType;
  /**
   * 결제 금융사
   */
  financial_company_code: FinancialCompanyCode | null;
  /**
   * 최소 금액
   */
  min_amount: number | null;
  /**
   * 할인 금액
   */
  discount_amount: number | null;
  /**
   * 결제 알림 문구 리스트
   */
  payment_notification_content_list: GetMaximumBenefit_payment_notification_list_item_list_payment_notification_content_list[];
}

export interface GetMaximumBenefit_payment_notification_list {
  /**
   * 결제 알림 정보 목록
   */
  item_list: GetMaximumBenefit_payment_notification_list_item_list[];
}

export interface GetMaximumBenefit_pdp_user_base_info_pdp_user_account_point {
  available_point: number | null;
}

export interface GetMaximumBenefit_pdp_user_base_info_pdp_user_account_mileage {
  available_mileage: number | null;
}

export interface GetMaximumBenefit_pdp_user_base_info_pdp_max_coupon_discount {
  discount_amount: number;
  discount_type: string;
  user_account_coupon_policy_id: string;
  issue_status: string;
  title: string;
  registration_type: PdpCouponRegistrationType | null;
}

export interface GetMaximumBenefit_pdp_user_base_info_pdp_duplication_coupon_discount_badge_text {
  text: string;
}

export interface GetMaximumBenefit_pdp_user_base_info_pdp_duplication_coupon_discount_badge_background_color {
  normal: string | null;
  dark: string | null;
}

export interface GetMaximumBenefit_pdp_user_base_info_pdp_duplication_coupon_discount_badge {
  /**
   * 텍스트 정보
   */
  text: GetMaximumBenefit_pdp_user_base_info_pdp_duplication_coupon_discount_badge_text;
  /**
   * 텍스트 배경에 적용될 음영 색상 정보
   */
  background_color: GetMaximumBenefit_pdp_user_base_info_pdp_duplication_coupon_discount_badge_background_color;
}

export interface GetMaximumBenefit_pdp_user_base_info_pdp_duplication_coupon_discount {
  discount_amount: number;
  discount_type: string;
  user_account_coupon_policy_id: string;
  issue_status: string;
  title: string;
  registration_type: PdpCouponRegistrationType | null;
  badge: GetMaximumBenefit_pdp_user_base_info_pdp_duplication_coupon_discount_badge | null;
}

export interface GetMaximumBenefit_pdp_user_base_info {
  /**
   * 계정에 연동된 포인트 정보
   */
  pdp_user_account_point: GetMaximumBenefit_pdp_user_base_info_pdp_user_account_point | null;
  /**
   * 계정에 연동된 마일리지 정보
   */
  pdp_user_account_mileage: GetMaximumBenefit_pdp_user_base_info_pdp_user_account_mileage | null;
  /**
   * 유저의 쿠폰 할인 정보 (discount_price 파라미터를 기반으로 정보 제공)
   */
  pdp_max_coupon_discount: GetMaximumBenefit_pdp_user_base_info_pdp_max_coupon_discount | null;
  /**
   * 유저의 중복 쿠폰 할인 정보 (discount_price 파라미터를 기반으로 정보 제공)
   */
  pdp_duplication_coupon_discount: GetMaximumBenefit_pdp_user_base_info_pdp_duplication_coupon_discount | null;
}

export interface GetMaximumBenefit_pdp_option_info_catalog_product_product_option_list_value_list {
  id: string;
}

export interface GetMaximumBenefit_pdp_option_info_catalog_product_product_option_list {
  /**
   * 속성 값
   */
  value_list: GetMaximumBenefit_pdp_option_info_catalog_product_product_option_list_value_list[];
}

export interface GetMaximumBenefit_pdp_option_info_catalog_product {
  /**
   * 상품 품목 부가 속성 리스트
   */
  product_option_list: GetMaximumBenefit_pdp_option_info_catalog_product_product_option_list[];
}

export interface GetMaximumBenefit_pdp_option_info {
  /**
   * 입점형 내재화 상품정보
   */
  catalog_product: GetMaximumBenefit_pdp_option_info_catalog_product;
}

export interface GetMaximumBenefit {
  /**
   * 주어진 조건 모두에 일치하는 결제 이벤트 정보를 반환한다.
   * 조건에 맞는 결제 이벤트 정보가 없으면 빈 목록을 반환한다.
   */
  payment_event_list_for_display: GetMaximumBenefit_payment_event_list_for_display;
  /**
   * 주어진 조건 모두에 일치하는 결제 알림 정보를 반환한다.
   * 조건에 맞는 결제 알림 정보가 없으면 빈 목록을 반환한다.
   */
  payment_notification_list: GetMaximumBenefit_payment_notification_list;
  /**
   * 유저의 기본 정보 및 혜택 정보
   */
  pdp_user_base_info: GetMaximumBenefit_pdp_user_base_info | null;
  /**
   * 입점형 PDP 상품 옵션 정보
   * catalog_product_detail_page와 동일한 타입을 반환하지만 옵션과 관련된 필드만 채워서 응답한다.
   */
  pdp_option_info: GetMaximumBenefit_pdp_option_info | null;
}

export interface GetMaximumBenefitVariables {
  input?: PdpUserBaseInfoInput | null;
  catalog_product_id: string;
  payment_event_target_list: PaymentEventTargetInput[];
  product_type_list?: PaymentProductType[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum FinancialCompanyCode {
  B_BUSAN = "B_BUSAN",
  B_CITY = "B_CITY",
  B_DAEGU = "B_DAEGU",
  B_GWANGJU = "B_GWANGJU",
  B_GYEONGNAM = "B_GYEONGNAM",
  B_HANA = "B_HANA",
  B_HSBC = "B_HSBC",
  B_IBK = "B_IBK",
  B_JEJU = "B_JEJU",
  B_JEONBUK = "B_JEONBUK",
  B_KAKAOBANK = "B_KAKAOBANK",
  B_KB = "B_KB",
  B_KBANK = "B_KBANK",
  B_KDB = "B_KDB",
  B_KEB = "B_KEB",
  B_NH = "B_NH",
  B_POST = "B_POST",
  B_SC = "B_SC",
  B_SHINHAN = "B_SHINHAN",
  B_SHINHYUP = "B_SHINHYUP",
  B_SUHYUP = "B_SUHYUP",
  B_WOORI = "B_WOORI",
  C_BC = "C_BC",
  C_CITY = "C_CITY",
  C_GWANGJU = "C_GWANGJU",
  C_HANA = "C_HANA",
  C_HYUNDAI = "C_HYUNDAI",
  C_JEJU = "C_JEJU",
  C_JEONBUK = "C_JEONBUK",
  C_KAKAOBANK = "C_KAKAOBANK",
  C_KB = "C_KB",
  C_KBANK = "C_KBANK",
  C_KDB = "C_KDB",
  C_LOTTE = "C_LOTTE",
  C_NH = "C_NH",
  C_POST = "C_POST",
  C_SAMSUNG = "C_SAMSUNG",
  C_SHINHAN = "C_SHINHAN",
  C_SHINHYUP = "C_SHINHYUP",
  C_SUHYUP = "C_SUHYUP",
  C_WOORI = "C_WOORI",
  UNKNOWN = "UNKNOWN",
}

export enum PaymentMethod {
  BANK = "BANK",
  BENEPIA_POINT = "BENEPIA_POINT",
  CARD = "CARD",
  CONVENIENCE_STORE = "CONVENIENCE_STORE",
  CONVENIENCE_STORE_JP = "CONVENIENCE_STORE_JP",
  GLOBAL_CARD = "GLOBAL_CARD",
  KAKAOPAY = "KAKAOPAY",
  PHONE = "PHONE",
  POINT = "POINT",
  SIMPLE_BANK = "SIMPLE_BANK",
  SIMPLE_CARD = "SIMPLE_CARD",
  TOSSPAY = "TOSSPAY",
  UNDEFINED_PAYMENT_METHOD = "UNDEFINED_PAYMENT_METHOD",
  VBANK = "VBANK",
}

export enum PaymentNotificationType {
  EVENT = "EVENT",
  GUIDE = "GUIDE",
  NOTICE = "NOTICE",
}

export enum PaymentProductType {
  DIGITAL_ESIM = "DIGITAL_ESIM",
  DIGITAL_RENT_CAR = "DIGITAL_RENT_CAR",
  ON_SITE = "ON_SITE",
  OVERSEAS_PURCHASE_AGENCY = "OVERSEAS_PURCHASE_AGENCY",
  PREORDER = "PREORDER",
  TAX_FREE = "TAX_FREE",
}

export enum PdpCouponRegistrationType {
  BOOKMARK = "BOOKMARK",
  MEMBERSHIP = "MEMBERSHIP",
}

export enum VendorEventType {
  CARD_CLAIM = "CARD_CLAIM",
  PG_COUPON = "PG_COUPON",
  PG_POINT = "PG_POINT",
}

/**
 * 결제 이벤트 대상 정보 (user-pay)
 */
export interface PaymentEventTargetInput {
  shop_id: string;
}

export interface PdpUserBaseInfoInput {
  catalog_product_id?: string | null;
  discount_price?: number | null;
  final_price?: number | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
